import { OrderDirection } from "@/constants/orderDirection";
import { z } from "zod";
import type { GetAppIntegrationUsersParams } from "../-query/type";
import { SortColumns, TAB_FILTER } from "./-constants";

export const SearchSchema = z.object({
  category: z.nativeEnum(TAB_FILTER).default(TAB_FILTER.FOLLOWING),
  pageSize: z.number().int().min(1).default(100),
  pageIndex: z.number().int().min(0).default(0),
  orderBy: z.nativeEnum(SortColumns).optional(),
  orderDirection: z.nativeEnum(OrderDirection).optional(),
  personId: z.string().optional(),
  freeText: z.string().optional(),
  roleIdIn: z.array(z.string()).optional(),
  statusIdIn: z.array(z.string()).optional(),
}) satisfies z.ZodType<GetAppIntegrationUsersParams>;

export type SearchSchema = z.infer<typeof SearchSchema>;
